import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface EmptyWorkspaceProps {
  onCreate: () => void;
}

export default function EmptyWorkspace({ onCreate }: EmptyWorkspaceProps) {
  const { t } = useTranslation();
  return (
    <div className='flex w-full justify-center p-3'>
      <button
        onClick={onCreate}
        className='group flex w-[246px] flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-ws-border py-3 transition-colors hover:border-ws-primary hover:bg-ws-primary/5'
      >
        <div className='flex h-10 w-10 items-center justify-center rounded-full border border-ws-border bg-ws-btn transition-colors group-hover:border-ws-primary group-hover:bg-ws-primary group-hover:text-white'>
          <Plus className='h-5 w-5 text-ws-text group-hover:text-white' />
        </div>
        <p className='text-sm font-medium text-ws-muted group-hover:text-ws-primary'>
          {t('experience.emptyWorkspace')}
        </p>
      </button>
    </div>
  );
}
